import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

const cartSliderSlice = createSlice({
  name: "cartSlider",
  initialState,
  reducers: {

    // ✅ OPEN
    openCartSlider: (state) => {
      state.isOpen = true;
      console.log("✅ REDUX OPEN CART");
    },

    // ❌ CLOSE
    closeCartSlider: (state) => {
      state.isOpen = false;
      console.log("❌ REDUX CLOSE CART");
    },

    // 🔥 FORCE RESET (IMPORTANT FIX)
    resetCartSlider: (state) => {
      state.isOpen = false;
      console.log("🔁 REDUX RESET CART SLIDER");
    },

    // 🔥 SAFE TOGGLE (optional use)
    toggleCartSlider: (state) => {
      state.isOpen = !state.isOpen;
      console.log("🔄 REDUX TOGGLE CART");
    },
  },
});

export const {
  openCartSlider,
  closeCartSlider,
  resetCartSlider,
  toggleCartSlider,
} = cartSliderSlice.actions;

export default cartSliderSlice.reducer;